import type {
  CenterMapProps,
  HandleMapClickProps,
} from "./map-interactive.type";
import type { GM_LatLngBounds, MapMarker } from "../map.type";

import { roundLatLng } from "@/modules/map";

import {
  MAP_DEFAULT_CENTER,
  MAP_DEFAULT_ZOOM,
} from "./map-interactive.constant";

export const handleMapClick = ({ event, onMapClick }: HandleMapClickProps) => {
  if (!onMapClick) return;

  const latLng = event.detail.latLng;

  if (!latLng) return;

  onMapClick({
    lat: roundLatLng(latLng.lat),
    lng: roundLatLng(latLng.lng),
  });
};

export const getLatLngBounds = (markers: MapMarker[]): GM_LatLngBounds => {
  const bounds = new google.maps.LatLngBounds();

  markers.forEach((marker) => {
    bounds.extend(marker.position);
  });

  return bounds;
};

export const centerMap = ({
  map,
  markers,
  fitBoundsPadding,
}: CenterMapProps) => {
  if (!map) return;

  if (!markers?.length) {
    map.setCenter(MAP_DEFAULT_CENTER);
    map.setZoom(MAP_DEFAULT_ZOOM);
    return;
  }

  if (markers.length === 1) {
    map.setCenter(markers[0].position);
    map.setZoom(MAP_DEFAULT_ZOOM);
    return;
  }

  const bounds = getLatLngBounds(markers);
  map.fitBounds(bounds, fitBoundsPadding);
};
